import { axios, getConfigs, IRequestConfig } from './api'

export enum PatientContactRelationship {
  SPOUSE = 'SPOUSE',
  FATHER = 'FATHER',
  MOTHER = 'MOTHER',
  SON = 'SON',
  DAUGHTER = 'DAUGHTER',
  BROTHER = 'BROTHER',
  SISTER = 'SISTER',
  GRANDSON = 'GRANDSON',
  GRANDDAUGHTER = 'GRANDDAUGHTER',
  UNCLE = 'UNCLE',
  AUNT = 'AUNT',
  NEPHEW = 'NEPHEW',
  NIECE = 'NIECE',
  CAREGIVER = 'CAREGIVER',
  OTHER = 'OTHER',
}

export interface PatientContactDto {
  id: number
  patientId: number
  firstName: string
  lastName: string
  dateOfBirth?: Date
  email?: string
  phone?: string
  whatsapp?: string
  relationshipType: PatientContactRelationship
  isLegalGuardian: boolean
  canRequestReport: boolean
  is2fa: boolean
}

export class PatientContactsService {
  private static readonly endpoint = 'patient-contact'

  static getByPatientId(patientId: number): Promise<PatientContactDto[]> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        `${this.endpoint}/patient/${patientId}`,
        {},
      )
      axios(configs, resolve, reject)
    })
  }

  static create(
    data: Omit<PatientContactDto, 'id'>,
  ): Promise<PatientContactDto> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        this.endpoint,
        {},
      )
      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  static update(
    id: number,
    data: Partial<Omit<PatientContactDto, 'id'>>,
  ): Promise<PatientContactDto> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        `${this.endpoint}/${id}`,
        {},
      )
      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  static delete(id: number): Promise<PatientContactDto> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        `${this.endpoint}/${id}`,
        {},
      )
      axios(configs, resolve, reject)
    })
  }
}
